import { render, staticRenderFns } from "./supplierOrderDetails.vue?vue&type=template&id=a446ce12&scoped=true"
import script from "./supplierOrderDetails.vue?vue&type=script&lang=js"
export * from "./supplierOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a446ce12",
  null
  
)

export default component.exports